import React from 'react';
import { Sidebar } from './Sidebar';
import { MainContent } from './MainContent';
import { MobileBottomNav } from './MobileBottomNav';

interface AppShellProps {
  children: React.ReactNode;
}

export const AppShell: React.FC<AppShellProps> = ({ children }) => {
  return (
    <div className="relative min-h-screen bg-gray-50 dark:bg-gray-900">
      <Sidebar />
      <MainContent>{children}</MainContent>
      <MobileBottomNav />
    </div>
  );
};
